module.exports = __webpack_public_path__ + "static/media/zocaloPvc1.3619661f.jpg";